import { Utility } from 'src/app/shared/utility';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewChecked, ChangeDetectorRef, DoCheck, EventEmitter,
  Input, OnChanges, Output, SimpleChanges, ViewChild
} from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormArray, ValidationErrors } from '@angular/forms';
import {
  PayScheduleEntry, CheckModel, PayFrequency, PaySchedule,
  ScheduleInput, PayScheduleHistory, CreateSchedule
} from 'src/app/models/pay-schedule.model';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { ScheduleService } from 'src/app/shared/services/pay-schedules/schedule.service';

// tslint:disable-next-line: no-conflicting-lifecycle
@Component({
  selector: 'app-create-schedule',
  templateUrl: './create-schedule.component.html',
  styleUrls: ['./create-schedule.component.css']
})

export class CreateScheduleComponent implements OnInit, OnChanges, AfterViewChecked, DoCheck {
  @ViewChild('PPEDate') ppeDatePicker: any;
  yr = 0;
  payScheduleEntrys: Array<PayScheduleEntry>;
  locs: Array<CheckModel>;
  systems: Array<CheckModel>;
  payFrequencyList: PayFrequency[];
  errorlist: string[] = [];
  schedulemsg = '';
  errorMsg = '';
  min: Date;
  max: Date;
  maxPaydate: Date;
  cfy: any;
  nfy: any;
  generated = false;
  readonly defaulttotalPays: number = 52;
  totalPaysList: Array<number> = [52, 53];
  selectedFrequency: any;
  totalPays: any;
  ipped: Date = new Date();
  pped: Date = new Date();
  ipd: Date = new Date();
  checkedBx = 0;
  requiresRegeneration = false;
  holidayList: any;
  schedule: PaySchedule;
  loadPage = false;
  allChecked = false;
  // Edit Schedule Functionality
  createdDetails: string;
  modifiedDetails: string;
  isEdit = false;
  isCreate = false;
  isContinue = false;
  orgName = '';
  payFrequency: PayFrequency;
  // kendo-dialog variable
  openChangesDialog = false;
  openSchedule = false;
  opened = false;
  @Input() scheduleInput: ScheduleInput;
  @Output() closeCreateSchedule = new EventEmitter();
  @Input() type: string;
  @Input() scheduleId = 0;
  @Input() scheduleHistory: PayScheduleHistory;
  @Output() changed = new EventEmitter();
  isSubmitted = false;
  cancelType = '';
  generateModel: any;
  beforeFormChange: any;
  toRegenerate: any;
  mainDiv: any;
  form: UntypedFormGroup;
  config: any;
  ppedErrorMsg: any;
  payDateErrorMsg: string[];
  ppedGreaterMsg: string;
  maxLengthRemarks = 250;
  defaultPF: any = { id: 0, type: '0', description: 'Select frequency' };
  defaultTP = 'Select total pays';
  generateBtnErrorMsg: any;
  submitBtnErrorMessage: any;
  isEmpScheduleId: boolean;
  hideEmpScheduleSection = false;
  inputValidationPattern = /^[A-Za-z0-9]+$/;

  constructor(
    private fb: UntypedFormBuilder,
    private cdRef: ChangeDetectorRef,
    private scheduleService: ScheduleService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngAfterViewChecked() {
    this.mainDiv = document.getElementById('scheduleDetails');
    this.disableOrgChange();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isSubmitted = false;
    if (this.form && this.form.touched) {
      this.cancel('Change');
    } else {
      setTimeout(() => {
        this.newForm();
        this.loadSchedule();
      }, 200);
    }
    document.getElementById('scheduleDetails').scrollIntoView();
  }

  ngOnInit() {
    this.config = this.readConfigService.getPayScheduleText();
    this.ppedErrorMsg = this.config.PPEDErrorMsg;
    this.payDateErrorMsg = this.config.PayDateErrorMsg;
    this.ppedGreaterMsg = this.config.PPEDGreaterMsg;
    document.getElementById('scheduleDetails').scrollIntoView();
  }

  ngDoCheck() {
    this.cdRef.detectChanges();
  }

  newForm(): void {
    this.form = this.fb.group({
      type: new UntypedFormControl(this.type),
      fiscalYear: new UntypedFormControl('', Validators.required),
      locations: this.fb.array([{}]),
      systems: this.fb.array([{}]),
      payFrequency: new UntypedFormControl('', Validators.required),
      totalPays: new UntypedFormControl('', Validators.required),
      contributoryCount: new UntypedFormControl(''),
      initialPayPeriodEndDate: new UntypedFormControl('', Validators.required),
      initialPayDate: new UntypedFormControl('', Validators.required),
      name: new UntypedFormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      employerScheduleId: new UntypedFormControl('', [Validators.maxLength(10), Utility.invalidAlphaNumeric]),
      comments: new UntypedFormControl('', [Validators.maxLength(250)]),
      payScheduleEntrys: this.fb.array([{}])
    }, { validator: Validators.compose([FormValidatorUtils.formValidators]) });
  }

  isValidDates(): boolean {
    const maxDate = new Date(this.max);
    let diffDates = 0;
    let idValid = true;
    const dates = this.form.controls.payScheduleEntrys['controls'];
    for (const date of dates) {
      const paydate = new Date(date.value.payDate);
      diffDates = paydate.getTime() - maxDate.getTime();
      if (diffDates > 0) {
        idValid = false;
      }
    }
    return idValid;
  }

  disableOrgChange(): void {
    // IN IE, WHEN KENDO DIALOG IS SHOWN AND OVERFLOW IS AUTO KENDO DISPLAY IS NOT AS EXPECTED
    if (this.mainDiv) {
      const isDialogOpened = this.openChangesDialog || this.openSchedule || this.opened;
      if (isDialogOpened) {
        if (this.mainDiv.style.overflow !== 'inherit') {
          this.mainDiv.style.overflow = 'inherit';
        }
      } else {
        if (this.mainDiv.style.overflow !== 'auto') {
          this.mainDiv.style.overflow = 'auto';
        }
      }
    }
    if (this.form && (this.form.touched || this.form.dirty) && !this.isSubmitted) {
      this.isSubmitted = true;
      this.changed.emit(true);
    }
  }

  // Create/Edit/continue Functionality
  loadSchedule(): void {
    this.startLoading();
    this.isSubmitted = false;
    this.resetValues();
    this.selectedFrequency = { id: 1, type: '7', description: 'Weekly' };

    this.payFrequencyList = this.scheduleInput.payFrequencies;
    this.payFrequency = this.payFrequencyList[0];

    if (this.type !== 'Edit') {
      this.cfy = this.scheduleInput.cfy;
      this.nfy = this.scheduleInput.nfy;
      this.locs = this.scheduleInput.locs;
      this.systems = this.scheduleInput.systems;
    }
    this.orgName = this.scheduleInput.orgName;

    if (this.type === 'Create') {
      this.createSchedule();
    } else if (this.type === 'Edit') {
      this.editSchedule();
    } else if (this.type === 'ContinuePartial') {
      this.continuePartial();
    } else {
      this.continueSchedule();
    }
  }

  createSchedule(): void {
    this.payFrequency = this.defaultPF;
    this.totalPays = this.defaultTP;
    this.isCreate = true;
    this.generated = false;
    this.isEmpScheduleId = false;
    this.form.patchValue({ payFrequency: this.defaultPF });
    this.populateArrays('systems', this.systems);
    this.populateArrays('locations', this.locs);
    this.loadPage = true;
    this.stopLoading();
  }

  editSchedule(): void {
    this.isEdit = true;
    this.getSchedule(this.scheduleId, this.type);
  }

  continuePartial(): void {
    this.isContinue = true;
    this.getPartial(this.scheduleHistory);
  }

  continueSchedule(): void {
    this.isContinue = true;
    this.getSchedule(this.scheduleId, this.type);
  }

  formReset(): void {
    this.loadPage = false;
    this.newForm();
  }

  // Populate Data to form
  populateArrays(type: string, arry: any) {
    const frmArray = this.form.get(type) as UntypedFormArray;
    while (frmArray.length > 0) { frmArray.removeAt(0); }
    let item: CheckModel;
    if (arry.length > 0) {
      for (item of arry) {
        const grp = this.fb.group({
          checked: [item.checked],
          text: [item.text],
          value: [item.value]
        });
        frmArray.push(grp);
      }
      // tslint:disable-next-line: no-use-before-declare
      frmArray.setValidators(FormValidatorUtils.atleastOneChecked);
    }
  }

  populateSchedules(arry: any) {
    const frmArray = this.clearPayscheduleEntry();
    let item: PayScheduleEntry;
    if (arry.length > 0) {
      for (item of arry) {
        const grp = this.fb.group({
          holidayOrWeekendName: [item.holidayOrWeekendName],
          id: [item.id],
          isActive: [item.isActive],
          isContributory: [item.isContributory],
          isHolidayOrWeekend: [item.isHolidayOrWeekend],
          isSubmitted: [item.isSubmitted],
          payDate: [item.payDate, Validators.required],
          payPeriodEndDate: [item.payPeriodEndDate, Validators.required],
          isLocked: [item.isLocked],
          remarks: [item.remarks],
          pdValid: [item.pdValid, Validators.required]
        });
        frmArray.push(grp);
      }
    }
  }

  selectionChange(value: any): void {
    switch (value.description) {
      case 'Weekly':
        this.totalPaysList = [52, 53];
        break;
      case 'Biweekly':
        this.totalPaysList = [18, 19, 20, 21, 22, 23, 24, 26, 27];
        break;
      case 'Semimonthly (Pay 15th & last day of month)':
        this.totalPaysList = [18, 19, 20, 21, 22, 23, 24];
        break;
      case 'Monthly':
        this.totalPaysList = [10, 12];
        break;
      case 'Quarterly':
        this.totalPaysList = [4];
        break;
      case 'Semiannually':
        this.totalPaysList = [2];
        break;
    }
    this.totalPays = this.defaultTP;
  }

  // PopUps/modals
  cancel(args: string): void {
    this.cancelType = args;
    if (this.form.touched) {
      this.opened = true;
      this.stopLoading();
    } else {
      this.loadPage = false;
      this.closeConfirm('yes');
    }
  }

  closeConfirm(status: string): void {
    if (status === 'yes') {
      if (this.form.touched) {
        this.startLoading();
        this.resetValues();
        this.formReset();
        if (this.cancelType !== 'cancel') {
          this.loadSchedule();
        } else {
          this.closeCreateSchedule.emit(false);
        }
        this.isSubmitted = false;
        this.changed.emit(false);
        this.stopLoading();
      } else {
        this.closeCreateSchedule.emit(false);
        this.changed.emit(false);
      }
    }
    this.opened = false;
  }

  displayResult(response: any) {
    if (response.success) {
      this.changed.emit(false);
    }
    this.notificationService.setUpNotification(response);
  }

  // Data modifying
  clearPayscheduleEntry() {
    const frmArray = this.form.get('payScheduleEntrys') as UntypedFormArray;
    while (frmArray.length > 0) { frmArray.removeAt(0); }
    return frmArray;
  }

  nonContrib(args) {
    if (this.isEdit) {
      const value = this.form.value;
      this.form.controls.NonContr.setValue(value.totalPays - value.contributoryCount);
    }
  }

  unCheckAll(args: any): void {
    const checked = args;
    const formcontrol = (this.form.controls.payScheduleEntrys as UntypedFormArray).controls;
    for (const form of formcontrol) {
      (form as UntypedFormGroup).controls.isContributory.setValue(checked);
    }
    this.countCheckBoxes();
  }

  addDays(date: Date, days: number): Date {
    if (date && days) {
      const tempDate = new Date(date.getFullYear(), date.getMonth(), date.getDay());
      tempDate.setDate(days);
      return tempDate;
    }
  }

  // Data validation while Create/Edit
  fiscalYearChange() {
    this.generated = false;
    const fiscalYear = this.yr;
    // hours 4 for avoiding kendo compare issue
    this.min = new Date(fiscalYear - 1, 6, 1);
    this.max = new Date(fiscalYear, 5, 30);
    this.maxPaydate = new Date(fiscalYear, 6, 31);
    this.getHolidays(fiscalYear);
  }

  getErrorMessage(dt: Date, type: string): string {
    let errMsg = '';
    if (this.isWeekend(dt) && this.ppedErrorMsg && this.payDateErrorMsg) {
      errMsg = type === 'PPED' ? this.ppedErrorMsg[0] : this.payDateErrorMsg[0];
    } else if (this.isHoliday(dt)) {
      errMsg = type === 'PPED' ? this.ppedErrorMsg[1] : this.payDateErrorMsg[1];
    }
    return errMsg;
  }

  validatePPED(model: any, index: number) {
    if (this.isInValidDate(model.payPeriodEndDate)) {
      model.isHolidayOrWeekend = true;
      model.holidayOrWeekendName = this.getErrorMessage(model.payPeriodEndDate, 'PPED');

    }
    this.form.controls.payScheduleEntrys['controls'][index].controls.isHolidayOrWeekend.setValue(model.isHolidayOrWeekend);
    this.form.controls.payScheduleEntrys['controls'][index].controls.holidayOrWeekendName.setValue(model.holidayOrWeekendName);
  }

  validatePayDate(model: any, index: number) {
    if (this.isInValidDate(model.payDate)) {
      model.isHolidayOrWeekend = true;
      model.holidayOrWeekendName = this.getErrorMessage(model.payDate, 'PayDate');
    }
    this.form.controls.payScheduleEntrys['controls'][index].controls.isHolidayOrWeekend.setValue(model.isHolidayOrWeekend);
    this.form.controls.payScheduleEntrys['controls'][index].controls.holidayOrWeekendName.setValue(model.holidayOrWeekendName);
  }

  isHoliday(args: Date): boolean {
    if (args) {
      const holidays = this.holidayList;
      for (const holiday of holidays) {
        if (args.toDateString() === new Date(holiday).toDateString()) {
          return true;
        }
      }
    }
    return false;
  }

  isWeekend(args: Date): boolean {
    return args && (args.getDay() % 6) === 0;
  }

  isInValidDate(args: any) {
    if (args) {
      if (this.isHoliday(args)) { return true; }
      if (this.isWeekend(args)) { return true; }
    }
    return false;
  }

  countCheckBoxes(): void {
    const entrys = this.form.controls.payScheduleEntrys.value;
    this.checkedBx = entrys.filter((x: any) => x.isContributory).length;
    this.allChecked = (this.checkedBx === entrys.length);
  }

  isEnabled(args: any) {
    if (args && this.isInValidDate(args)) {
      return 'k-state-disabled disableDate';
    }
  }

  onNameChange(name: string) {
    name = name.trim();
    this.form.controls['name'].setValue(name);
    let exists = false;
    if (name.length > 0) {
      const obj = {
        userInfo: this.scheduleService.UserInfo(),
        name,
        fiscalYear: this.yr.toString()
      };
      this.scheduleService.nameExists(obj)
        .subscribe((response) => {
          exists = response;
          if (exists) {
            this.form.controls.name.setErrors({ nameExists: true });
          } else {
            this.form.controls.name.setErrors(null);
          }
        },
          (err: HttpErrorResponse) => {
            console.log(err);
            this.notificationService.setErrorNotification();
          });
    }
  }

  onEmpIdChange(empScheduleId: string) {
    empScheduleId = empScheduleId.trim();
    const invalidAlphaNumeric = (empScheduleId && this.inputValidationPattern.test(empScheduleId));
    this.form.controls['employerScheduleId'].setValue(empScheduleId);
    if (invalidAlphaNumeric && !(empScheduleId.length > 10)) {
      let empScheduleIdExists = false;
      if (empScheduleId.length > 0) {
        const obj = {
          userInfo: this.scheduleService.UserInfo(),
          EmployerScheduleID: empScheduleId,
          fiscalYear: this.yr.toString()
        };
        this.scheduleService.empScheduleIdExists(obj)
          .subscribe((response) => {
            empScheduleIdExists = response.isExists;
            if (empScheduleIdExists) {
              this.form.controls.employerScheduleId.setErrors({ empScheduleIdExists: true });
            } else {
              this.form.controls.employerScheduleId.setErrors(null);
            }
          },
            (err: HttpErrorResponse) => {
              console.log(err);
              this.notificationService.setErrorNotification();
            });
      }
    }
  }

  isPDOutOfRange(payDate: Date, payPeriodEndDate: Date) {
    const originalPD: any = new Date(payDate);
    const originalPPED: any = new Date(payPeriodEndDate);
    const dayDiff: any = Math.abs((originalPD - originalPPED) / (1000 * 60 * 60 * 24));
    if (dayDiff >= 32) {
      return null;
    } else {
      return true;
    }
  }

  onDateChange(model: any, type: string, index: number) {
    model.isHolidayOrWeekend = false;
    model.pdValid = this.isPDOutOfRange(model.payDate, model.payPeriodEndDate);
    if (this.form && this.form.controls && this.form.controls.payScheduleEntrys && this.form.controls.payScheduleEntrys['controls']) {
      this.form.controls.payScheduleEntrys['controls'][index].controls.pdValid.setValue(model.pdValid);
    }
    if (model.payPeriodEndDate > model.payDate) {
      model.isHolidayOrWeekend = true;
      model.holidayOrWeekendName = this.ppedGreaterMsg;
      return;
    }
    if (model.pdValid) {
      if (type === 'PPED') {
        this.validatePPED(model, index);
        if (!model.isHolidayOrWeekend) { this.validatePayDate(model, index); }
      } else {
        this.validatePayDate(model, index);
        if (!model.isHolidayOrWeekend) { this.validatePPED(model, index); }
      }
    }
  }

  resetValues(): void {
    this.loadPage = false;
    this.isEdit = false;
    this.isCreate = false;
    this.isContinue = false;
    this.generated = false;
    this.payScheduleEntrys = [];
    this.schedule = new PaySchedule();
    this.yr = 0;
    this.createdDetails = '';
    this.modifiedDetails = '';
  }

  // Service Calls
  generate(model: any, valid: any): void {
    this.beforeFormChange = null;
    model.isSchedulePartial = false;
    const payCount = model.totalPays;
    const initialPped = new Date(model.initialPayPeriodEndDate);
    const cFyed = new Date(this.yr, 5, 30, 0, 0, 0);
    if (payCount === 52 || payCount === 26) {
      const expectedPayCounts = this.totalPayDates(initialPped, cFyed, payCount);
      if (payCount !== expectedPayCounts) {
        model.isSchedulePartial = true;
        this.generateModel = model;
        this.schedulemsg = this.config.ScheduleMsg.replace('{0}', expectedPayCounts)
          .replace('{1}', expectedPayCounts).replace('{2}', payCount);
        this.openSchedule = true;
        return;
      }
    }
    this.scheduleGenerate(model);
  }

  continueGenerate() {
    this.openSchedule = false;
    this.scheduleGenerate(this.generateModel);
  }

  scheduleGenerate(model: any) {
    const paySchedule: any = new CreateSchedule();
    paySchedule.actionType = 'Create';
    paySchedule.payCount = model.totalPays;
    paySchedule.systems = model.systems;
    paySchedule.contributoryCount = model.contributoryCount || 0;
    paySchedule.isCurrentFiscalYear = this.yr === this.cfy;
    paySchedule.selectedPayFrequencyText = model.payFrequency.description;
    paySchedule.SelectedPayFrequencyId = model.payFrequency.id;
    paySchedule.isSchedulePartial = model.isSchedulePartial;
    paySchedule.initialPayPeriodEndDate = model.initialPayPeriodEndDate;
    paySchedule.fiscalYear = this.yr;
    paySchedule.name = model.name;
    const payDays = this.selectedFrequency.type * this.totalPays;
    const lastPayDate = this.addDays(model.initialPayDate, payDays);
    paySchedule.initialPayDate = model.initialPayDate;
    paySchedule.lastPayDate = lastPayDate;
    this.beforeFormChange = paySchedule;
    paySchedule.userInfo = this.scheduleService.UserInfo();
    this.scheduleService.generateScheduleEntrys(paySchedule)
      .subscribe(payScheduleEntr => {
        this.payscheduleGenerated(payScheduleEntr);
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.notificationService.setErrorNotification();
        });
  }

  payscheduleGenerated(args: any) {
    this.generateBtnErrorMsg = null;
    if (args) {
      if (args.success) {
        const paySchedule = args.message;
        this.payScheduleEntrys = paySchedule.payScheduleEntrys;
        if (this.payScheduleEntrys !== undefined) {
          this.generated = false;
          this.checkedBx = this.payScheduleEntrys.length;
          for (let i = 0; i < this.checkedBx; i++) {
            this.payScheduleEntrys[i].payPeriodEndDate = new Date(this.payScheduleEntrys[i].payPeriodEndDate);
            this.payScheduleEntrys[i].payDate = new Date(this.payScheduleEntrys[i].payDate);
            const originalPD: any = new Date(this.payScheduleEntrys[i].payDate);
            const originalPPED: any = new Date(this.payScheduleEntrys[i].payPeriodEndDate);
            this.payScheduleEntrys[i].pdValid = this.isPDOutOfRange(originalPD, originalPPED);
          }
          this.allChecked = !(this.payScheduleEntrys.filter(x => !x.isContributory).length > 0);
          if (this.payScheduleEntrys.length > 0) {
            this.populateSchedules(this.payScheduleEntrys);
            this.generated = true;
          }
        }
        if (document.getElementById('scrollToEntries') && this.isCreate) {
          document.getElementById('scrollToEntries').scrollIntoView();
        }
      } else {
        if (args.message) {
          this.generateBtnErrorMsg = args.message;
        }
      }
    } else {
      this.notificationService.setErrorNotification();
    }
  }

  getSchedule(id: number, action: string): void {
    const obj = { id, actionType: action, userInfo: this.scheduleService.UserInfo() };
    this.scheduleService.getSchedules(obj)
      .subscribe(response => {
        if (response) {
          if (response.success) {
            const paySchedule = response.model;
            this.schedule = paySchedule;
            this.payScheduleEntrys = paySchedule.payScheduleEntrys;
            this.yr = paySchedule.fiscalYear;
            this.fiscalYearChange();
            this.getHolidays(this.yr);
            this.createdDetails = this.scheduleHistory.createdDetails;
            this.modifiedDetails = this.scheduleHistory.modifiedDetails;
            this.systems = paySchedule.systems;
            this.locs = paySchedule.locations;
            this.payFrequency = this.payFrequencyList.filter(x => x.id === paySchedule.selectedPayFrequencyId)[0];
            this.totalPays = paySchedule.payCount;
            if (action === 'ContinueSchedule') {
              this.isEmpScheduleId = false;
            } else {
              this.isEmpScheduleId = paySchedule.employerScheduleID ? true : false;
            }
            this.form.patchValue({
              fiscalYear: this.yr,
              totalPays: paySchedule.payCount,
              contributoryCount: paySchedule.contributoryCount,
              name: paySchedule.name,
              employerScheduleId: (action === 'ContinueSchedule') ? '' : paySchedule.employerScheduleID,
              comments: paySchedule.comments,
              payFrequency: this.payFrequency
            });
            if (this.type === 'Edit') {
              this.form.addControl('selectedScheduleId', new UntypedFormControl(paySchedule.selectedScheduleId));
              this.form.addControl('NonContr', new UntypedFormControl(paySchedule.payCount - paySchedule.contributoryCount));
              this.form.controls.initialPayPeriodEndDate.setValidators(null);
              this.form.controls.initialPayDate.setValidators(null);
              this.form.controls.payFrequency.setValidators(null);
            } else {
              if (paySchedule.initialPayDate && paySchedule.initialPayPeriodEndDate) {
                this.form.patchValue({
                  initialPayPeriodEndDate: new Date(paySchedule.initialPayPeriodEndDate),
                  initialPayDate: new Date(paySchedule.initialPayDate)
                });
              }
            }
            this.populateArrays('systems', this.systems);
            this.populateArrays('locations', this.locs);
            if (this.payScheduleEntrys !== null) {
              for (const payScheduleEntry of this.payScheduleEntrys) {
                payScheduleEntry.payPeriodEndDate = new Date(payScheduleEntry.payPeriodEndDate);
                payScheduleEntry.payDate = new Date(payScheduleEntry.payDate);
              }
              this.payscheduleGenerated({ success: true, message: paySchedule });
            } else {
              this.generated = false;
            }
            this.loadPage = true;
          } else {
            this.notificationService.setErrorNotification(response.message);
          }
        } else {
          this.notificationService.setErrorNotification();
        }
        this.stopLoading();
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.stopLoading();
          this.notificationService.setErrorNotification();
        });
  }

  totalPayDates(date1: any, date2: any, frequency: any) {
    let givenDate = date1;
    const fiscalDt = date2;
    let payCount = 0;
    while (givenDate <= fiscalDt) {
      switch (frequency) {
        case 52:
          givenDate = new Date(givenDate.setDate(givenDate.getDate() + 7));
          break;
        case 26:
          givenDate = new Date(givenDate.setDate(givenDate.getDate() + 14));
          break;
      }
      payCount++;
    }
    return payCount || 0;
  }

  saveScheduleData(model: any, valid: boolean, type: string): void {
    this.errorlist = [];
    this.requiresRegeneration = false;
    if (valid) {
      if (this.beforeFormChange.initialPayPeriodEndDate !== model.initialPayPeriodEndDate) {
        this.errorlist.push('Pay period end date');
      }
      if (this.beforeFormChange.initialPayDate !== model.initialPayDate) {
        this.errorlist.push('Initial Pay date');
      }
      if (this.beforeFormChange.SelectedPayFrequencyId !== model.payFrequency.id) {
        this.errorlist.push('Pay frequency');
        this.requiresRegeneration = true;
      }
      if (!this.requiresRegeneration && this.beforeFormChange.fiscalYear !== model.fiscalYear) {
        this.errorlist.push('Fiscal Year');
        this.requiresRegeneration = true;
      }
      if (this.errorlist.length < 1) {
        this.saveNewSchedule(model, valid, type);
      } else {
        this.toRegenerate = model;
        this.openChangesDialog = true;
      }
    }
  }

  changesDialog(changeType: string): void {
    this.openChangesDialog = false;
    const model = this.toRegenerate;
    if (changeType === 'Regenerate') {
      this.generated = false;
      this.generate(model, true);
    } else {
      this.saveNewSchedule(model, true, 'Create');
    }
    this.toRegenerate = null;
  }

  saveNewSchedule(model: any, valid: boolean, type: string): void {
    const scheduleRecords = model;
    this.startLoading();
    if (scheduleRecords !== null && scheduleRecords !== undefined) {
      const saveSchedule: any = new CreateSchedule();
      saveSchedule.actionType = type;
      saveSchedule.payCount = model.totalPays;
      saveSchedule.systems = model.systems;
      saveSchedule.initialContributoryCount = model.contributoryCount;
      saveSchedule.contributoryCount = model.contributoryCount;
      saveSchedule.isCurrentFiscalYear = this.yr === this.cfy;
      saveSchedule.initialPayPeriodEndDate = model.initialPayPeriodEndDate;
      saveSchedule.fiscalYear = this.yr;
      saveSchedule.name = model.name;
      saveSchedule.employerScheduleId = model.employerScheduleId;
      saveSchedule.comments = model.comments;
      saveSchedule.selectedPayFrequencyText = model.payFrequency.description;
      saveSchedule.SelectedPayFrequencyId = model.payFrequency.id;
      const payDays = this.selectedFrequency.type * this.totalPays;
      const lastPayDate = this.addDays(model.initialPayDate, payDays);
      saveSchedule.initialPayDate = model.initialPayDate;
      saveSchedule.lastPayDate = lastPayDate;
      saveSchedule.payScheduleEntrys = model.payScheduleEntrys;
      saveSchedule.locations = model.locations;
      saveSchedule.createdFrom = (type !== 'Create') ? this.schedule.createdFrom : 0;
      saveSchedule.organizationId = this.scheduleInput.orgId;
      saveSchedule.organizationName = this.scheduleInput.orgName;
      saveSchedule.selectedScheduleId = this.scheduleId;
      saveSchedule.userInfo = this.scheduleService.UserInfo();
      const scheduleYear = saveSchedule.fiscalYear;
      this.scheduleService.createSchedule(saveSchedule)
        .subscribe((response) => {
          if (response) {
            this.closeCreateSchedule.emit({ response, type, scheduleYear });
            if (response.success) {
              this.notificationService.setUpNotification(response);
            } else {
              this.notificationService.setErrorNotification(response.message);
            }
          } else {
            this.notificationService.setErrorNotification();
          }
          this.stopLoading();
        },
          (err: HttpErrorResponse) => {
            console.log(err);
            this.stopLoading();
            this.notificationService.setErrorNotification();
          });
    }
  }

  getPartial(model: any) {
    model.userInfo = this.scheduleService.UserInfo();
    this.scheduleService.getPartialSch(model)
      .subscribe(response => {
        if (response) {
          if (response.success) {
            const paySchedule = response.model;
            this.schedule = paySchedule;
            this.yr = paySchedule.fiscalYear;
            this.fiscalYearChange();
            this.getHolidays(this.yr);
            this.createdDetails = model.createdDetails;
            this.modifiedDetails = model.modifiedDetails;
            this.systems = paySchedule.systems;
            this.locs = paySchedule.locations;
            this.payFrequency = this.payFrequencyList.filter(x => x.id === paySchedule.selectedPayFrequencyId)[0];
            this.isEmpScheduleId = false;
            this.selectionChange(this.payFrequency);
            this.form.patchValue({
              fiscalYear: this.yr,
              totalPays: paySchedule.payCount,
              contributoryCount: paySchedule.contributoryCount,
              employerScheduleId: '',
              name: paySchedule.name,
              comments: paySchedule.comments,
              payFrequency: this.payFrequency
            });
            this.populateArrays('systems', this.systems);
            this.populateArrays('locations', this.locs);
            this.generated = false;
            this.loadPage = true;
          } else {
            this.notificationService.setErrorNotification(response.message);
          }
        } else {
          this.notificationService.setErrorNotification();
        }
        this.stopLoading();
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.stopLoading();
          this.notificationService.setErrorNotification();
        });
  }

  getHolidays(fiscalYear: number) {
    const obj = {
      fiscalYear,
      userInfo: this.scheduleService.UserInfo(),
    };
    this.scheduleService.getHolidays(obj)
      .subscribe(holidays => {
        if (holidays) {
          this.holidayList = holidays;
        } else {
          this.notificationService.setErrorNotification();
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.notificationService.setErrorNotification();
        });
  }

  saveEditSchedule(model: any, valid: boolean): void {
    this.submitBtnErrorMessage = null;
    if (valid) {
      this.startLoading();
      const schedule: any = this.schedule;
      schedule.userInfo = this.scheduleService.UserInfo();
      schedule.name = model.name;
      schedule.locations = model.locations;
      schedule.systems = model.systems;
      schedule.payScheduleEntrys = model.payScheduleEntrys;
      schedule.contributoryCount = model.contributoryCount;
      schedule.employerScheduleID = model.employerScheduleId;
      schedule.comments = model.comments;
      model.actionType = 'Edit';
      this.scheduleService.post(schedule)
        .subscribe((response) => {
          if (response) {
            this.closeCreateSchedule.emit({ response, type: this.type, editScheduleYear: Number(schedule.fiscalYear) });
            if (response.success) {
              this.notificationService.setUpNotification(response);
            } else {
              if (response.message) {
                this.submitBtnErrorMessage = response.message;
              }
            }
          } else {
            this.notificationService.setErrorNotification();
          }
          this.stopLoading();
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.stopLoading();
            this.notificationService.setErrorNotification();
          });
    }
  }

  ppedPaydate(): boolean {
    const payDate = this.form.controls.initialPayDate;
    const pped = this.form.controls.initialPayPeriodEndDate;
    if (!payDate.touched || !pped.touched) { return false; }
    if (payDate.errors && pped.errors) { return false; }
    return (payDate.value instanceof Date && pped.value instanceof Date && payDate.value < pped.value);
  }

  onValueChange(date: Date) {
    const inputdt = this.form.controls.initialPayPeriodEndDate.value;
    if (this.isDateDisabled(date)) {
      this.form.controls.initialPayPeriodEndDate.setValue(inputdt);
      this.ppeDatePicker.toggle(true);
    } else {
      this.form.controls.initialPayPeriodEndDate.setValue(date);
      this.ppeDatePicker.toggle(false);
    }
  }

  isDateDisabled(date: Date) {
    const desc = this.form.controls.payFrequency.value.description;
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    if (desc === 'Semimonthly (Pay 15th & last day of month)') {
      return !(date.getTime() === lastDay.getTime() || date.getDate() === 15);
    }
    return false;
  }

  startLoading() {
    this.notificationService.setUpLoading(true);
  }

  stopLoading() {
    setTimeout(() => { this.notificationService.setUpLoading(false); }, 200);
  }
}

export class FormValidatorUtils {
  static atleastOneChecked(control: any) {
    let isAtLeastOne = false;
    isAtLeastOne = control.value.filter(x => x.checked).length > 0;
    if (isAtLeastOne) {
      return null;
    }
    return { required: true };
  }

  static formValidators(control: any): ValidationErrors | null {
    if (control.value.contributoryCount > control.value.totalPays) {
      control.controls.contributoryCount.setErrors({ totalPayComparison: true });
    } else {
      control.controls.contributoryCount.setErrors(null);
    }
    if (!control.dirty) {
      control.controls.initialPayDate.disable = true;
      control.controls.initialPayPeriodEndDate.disable = true;
    }
    if (control.value.fiscalYear === undefined) {
      control.controls.fiscalYear.setErrors({ fiscalYr: true });
      return null;
    } else {
      control.controls.fiscalYear.setErrors(null);
      control.controls.initialPayDate.disable = false;
      control.controls.initialPayPeriodEndDate.disable = false;
      const desc = control.controls.payFrequency.value.description;
      const startDate = new Date(control.value.fiscalYear - 1, 6, 1);
      const endDate = new Date(control.value.fiscalYear, 5, 30);
      const ipd = control.value.initialPayDate;
      const pped = control.value.initialPayPeriodEndDate;
      if (pped instanceof Date) {
        let isValid = true;
        const lastppedDay = new Date(pped.getFullYear(), pped.getMonth() + 1, 0);
        if (pped < startDate || pped > endDate) {
          control.controls.initialPayPeriodEndDate.setErrors({ ppedNotInFY: true });
        } else {
          control.controls.initialPayPeriodEndDate.setErrors(null);
        }
        if (control.controls.initialPayPeriodEndDate.errors === null) {
          if (desc === 'Semimonthly (Pay 15th & last day of month)') {
            isValid = (pped.getTime() === lastppedDay.getTime() || pped.getDate() === 15);
          }
          if (!isValid) {
            control.controls.initialPayPeriodEndDate.setErrors({ notInPFreq: true });
          }
        }
      }
      if (ipd instanceof Date) {
        const originalPD: any = new Date(ipd);
        const originalPPED: any = new Date(pped);
        const dayDiff: any = Math.abs((originalPD - originalPPED) / (1000 * 60 * 60 * 24));
        if (ipd < startDate || ipd > endDate) {
          control.controls.initialPayDate.setErrors({ pdNotInFY: true });
        } else if (dayDiff && dayDiff >= 32) {
          control.controls.initialPayDate.setErrors({ pdGreater32Days: true });
        } else {
          control.controls.initialPayDate.setErrors(null);
        }
      }
      if (control.value.systems.filter(s => s.checked).length < 1) {
        control.controls.systems.setErrors({ systemNotChecked: true });
      } else {
        control.controls.systems.setErrors(null);
      }
      if (control.value.locations.filter(s => s.checked).length < 1) {
        control.controls.locations.setErrors({ locNotChecked: true });
      } else {
        control.controls.locations.setErrors(null);
      }
    }
    if (control.value.payScheduleEntrys.length > 1) {
      if (control.value.contributoryCount !== control.value.payScheduleEntrys.filter(x => x.isContributory).length) {
        control.controls.contributoryCount.setErrors({ checkBoxComparison: true });
      } else {
        control.controls.contributoryCount.setErrors(null);
      }
    }
    return null;
  }
}

